import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DefaultLayout from './layouts/DefaultLayout';

// Pages
import Login from './pages/Auth/Login';
import General from './pages/General';
import Autorizaciones from './pages/Autorizaciones';
import AutorizacionDetalle from './pages/AutorizacionDetalle';
import Cupos from './pages/Cupos';
import Capturas from './pages/Capturas';
import EspecieDetalle from './pages/EspecieDetalle';
import Usuarios from './pages/Usuarios';
import Logs from './pages/Logs';
import AgenteDetalle from './pages/AgenteDetalle';
import Visor from './pages/Visor';
import PanelInteligente from './pages/PanelInteligente';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Ruta pública */}
          <Route path="/login" element={<Login />} />

          {/* Rutas protegidas */}
          <Route element={<ProtectedRoute />}>
            <Route element={<DefaultLayout />}>
              <Route index element={<Navigate to="/general" replace />} />
              <Route path="/general" element={<General />} />
              <Route path="/autorizaciones" element={<Autorizaciones />} />
              <Route path="/autorizaciones/:id" element={<AutorizacionDetalle />} />
              <Route path="/cupos" element={<Cupos />} />
              <Route path="/capturas" element={<Capturas />} />
              <Route path="/capturas/:id" element={<EspecieDetalle />} />
              
              {/* Solo para no-cazadores */}
              {/* <Route element={<ProtectedRoute requireNotCazador />}> */}
                <Route path="/usuarios" element={<Usuarios />} />
              {/* </Route> */}

              {/* Solo para admin */}
              <Route element={<ProtectedRoute requireAdmin />}>
                <Route path="/logs" element={<Logs />} />
                <Route path="/logs/:id" element={<AgenteDetalle />} />
                <Route path="/visor" element={<Visor />} />
                <Route path="/ia" element={<PanelInteligente />} />
              </Route>
            </Route>
          </Route>

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;